import { render, staticRenderFns } from "./TableDemo.vue?vue&type=template&id=140f344e&"
import script from "./TableDemo.vue?vue&type=script&lang=js&"
export * from "./TableDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports